export enum DagHelperText {
  NodeDragInProgressText = "Please wait. Processing drag action of a node."
}
